import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  JenkinsRulesThresholds,
  Props
} from '../../../components/jenkins-rules-threshold'
import React from 'react'

interface ReadyProp {
  readonly ready: boolean
}

type BridgeProps = ReadyProp & Props

const props: Array<keyof Props> = [
  'orgUuid',
  'dropdownItems',
  'addSeverityOrRuleToModel',
  'allValues',
  'validateThreshold'
]

function AngularJenkinsRulesThresholds({ ready, ...props }: BridgeProps) {
  return ready ? <JenkinsRulesThresholds {...props} /> : null
}

export const reactJenkinsRulesThresholds = createNgReactBridgeDirective(
  'reactJenkinsRulesThresholds',
  [],
  AngularJenkinsRulesThresholds,
  [
    [
      'ready',
      {
        watchDepth: 'reference'
      }
    ],
    ...props
  ]
)
